module.exports = __webpack_public_path__ + "static/media/DSCF0295-arooiYgs.95de4bda.JPG";